define('models/pages/basket/basket-collection',[
    'underscore',
    'chaplin',
    'models/base/model',
    'models/base/collection',

    'models/pages/basket/basket',

    'lib/utils'
], function(
    _, Chaplin, Model, Collection,
    BasketModel
) {
    'use strict';

    var BasketCollection = Collection.extend({
        model: BasketModel,
        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    return BasketCollection;
});
